import { useState, useEffect } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

// Real Zillow reviews from Chris Pierog
const ZILLOW_REVIEWS = [
  {
    name: "Eva B.",
    rating: 5,
    text: "Chris was amazing! He was there the whole way, keeping us updated, giving honest opinions and fighting for the things we want with realistic expectations.",
    location: "Aberdeen, WA"
  },
  {
    name: "Angela M.",
    rating: 5,
    text: "Chris did an excellent job from beginning to end! He was knowledgeable and responsive at every turn. We love our new home and 100% recommend Chris!",
    location: "Ocean Shores, WA"
  },
  {
    name: "Christian L.",
    rating: 5,
    text: "Chris did a great job listing my property and getting it sold. He always knew when and how to negotiate with the other party.",
    location: "Aberdeen, WA"
  },
  {
    name: "Michael B.",
    rating: 5,
    text: "He instills confidence and a calm approach to everything. He clearly knows the market, the area, the process. Absolutely would recommend Chris to anyone.",
    location: "Montesano, WA"
  },
  {
    name: "Chase C.",
    rating: 5,
    text: "This wasn't our first house purchase and it wasn't our easiest, but it was the BEST one. Chris was responsive, pleasant, and knowledgeable.",
    location: "Hoquiam, WA"
  },
  {
    name: "Justin P.",
    rating: 5,
    text: "Chris is AMAZING! He is hands down the best realtor I have ever come across. His local area knowledge is unsurpassed.",
    location: "Aberdeen, WA"
  },
];

export const ZillowReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % ZILLOW_REVIEWS.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const currentReview = ZILLOW_REVIEWS[currentIndex];

  return (
    <section 
      className="py-12 md:py-16 bg-[#132723]"
      data-testid="zillow-reviews-section"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <span className="text-xl font-serif text-white">5.0</span>
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-white/60 text-sm">• 28 Zillow Reviews</span>
          </div>
        </div>

        <div className="bg-white p-6 md:p-8 relative">
          <div className="flex gap-0.5 justify-center mb-3">
            {[...Array(currentReview.rating)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
            ))}
          </div>

          <blockquote className="text-lg text-[#132723] text-center leading-relaxed mb-4">
            "{currentReview.text}"
          </blockquote>

          <div className="text-center">
            <p className="font-medium text-[#132723]">{currentReview.name}</p>
            <p className="text-sm text-[#4d6153]">{currentReview.location} • Zillow</p>
          </div>

          <button
            onClick={() => setCurrentIndex((prev) => (prev - 1 + ZILLOW_REVIEWS.length) % ZILLOW_REVIEWS.length)}
            className="absolute left-2 top-1/2 -translate-y-1/2 p-2 text-[#4d6153] hover:text-[#132723]"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={() => setCurrentIndex((prev) => (prev + 1) % ZILLOW_REVIEWS.length)}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-[#4d6153] hover:text-[#132723]"
          >
            <ChevronRight className="w-6 h-6" />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-4">
          {ZILLOW_REVIEWS.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all ${
                index === currentIndex ? "bg-white w-6" : "bg-white/40"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ZillowReviews;
